module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gw-3b1eba4bfbd859d523f4f9bba24a814a.svg";